import { render, staticRenderFns } from "./analItem.vue?vue&type=template&id=4b94bca6&scoped=true&"
import script from "./analItem.vue?vue&type=script&lang=js&"
export * from "./analItem.vue?vue&type=script&lang=js&"
import style0 from "./analItem.vue?vue&type=style&index=0&id=4b94bca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b94bca6",
  null
  
)

export default component.exports